import { Form } from "@redriver/cinnamon-mui";
import { reportingScheduleLookup } from "modules/lookups";

const ReportingScheduleDropdown = (props) => (
  <Form.Dropdown {...props} lookup={reportingScheduleLookup} />
);

export default ReportingScheduleDropdown;
